import { render, staticRenderFns } from "./ViewWorkflow.vue?vue&type=template&id=621bfae9"
import script from "./ViewWorkflow.vue?vue&type=script&lang=js"
export * from "./ViewWorkflow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports